import * as Cesium from 'cesium';
export const googleProviderInternals = (provider) => {
    const p = provider;
    if (!(p._resource instanceof Cesium.Resource) || typeof p._viewportUrl !== 'string' || !('_attributionsByLevel' in p)) {
        throw new Error('Cesium Google2DImageryProvider internals changed: viewport attribution cannot be scoped to the view');
    }
    return p;
};
export const viewportAttributionResource = (google, q) => google._resource.getDerivedResource({
    url: google._viewportUrl,
    queryParameters: { zoom: q.zoom, north: q.north, south: q.south, east: q.east, west: q.west },
});
// Takes over tile credits for an ion-served Google 2D layer. Returns null for
// any other provider.
export const scopeGoogleLayer = (provider) => {
    var _a, _b, _c;
    if (!(provider instanceof Cesium.IonImageryProvider))
        return null;
    const ion = provider;
    const inner = ion._imageryProvider;
    if (!(inner instanceof Cesium.Google2DImageryProvider))
        return null;
    const google = googleProviderInternals(inner);
    // Defined means Cesium never fires its own whole-world requests.
    google._attributionsByLevel = new Map();
    const credits = [...((_a = ion._tileCredits) !== null && _a !== void 0 ? _a : []), ...((_b = google._tileCredits) !== null && _b !== void 0 ? _b : [])];
    ion.getTileCredits = () => credits;
    return {
        google,
        tileWidth: inner.tileWidth,
        minLevel: inner.minimumLevel,
        maxLevel: (_c = inner.maximumLevel) !== null && _c !== void 0 ? _c : 22,
        credits,
        baseCount: credits.length,
        lastKey: null,
        requestSeq: 0,
    };
};
